import apiFetch from '../apiFetch'

export default function (token, customFieldId) {
  return apiFetch({ endPoint: `Masters/CustomField/${customFieldId}/Recover`, method: 'POST', body: null, token: token })
}
